import { type ActualItems } from './types'

export function getTotalAmountForCurrency(
  actualAmounts: ActualItems,
  currencyCode: string,
) {
  const items = actualAmounts.items
  const totalAmount = items
    .flatMap((item) => item.member_spend)
    .filter((spend) => spend.currency_code === currencyCode)
    .map((spend) => parseFloat(spend.amount))
    .reduce((total, amount) => total + amount, 0)

  return totalAmount
}
